// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-pill {
  position: relative;
  width: 100%;
  border-radius: 0 4px 0 0;
  overflow: hidden;
  height: 184px;
  margin: 24px 0;
}
.card-pill a {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
}
.card-pill__text {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--sebrae-white);
  background-color: rgba(20, 46, 82, 0.5);
}
.card-pill h3 {
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.card-pill p {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  margin-top: 3px;
}
.card-pill img, .card-pill iframe {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.card-pill__desktop {
  display: none !important;
}
.card-pill.right {
  border-radius: 0 !important;
}
.card-pill.right .card-pill__text {
  justify-content: flex-end;
  text-align: right;
  padding: 24px;
}
@media screen and (min-width: 1025px) {
  .card-pill__mobile {
    display: none !important;
  }
  .card-pill__desktop {
    display: flex !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cards/card-pill/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uCAAA;AACJ;AACE;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;AADJ;AAGE;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,eAAA;AAHJ;AAKE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAHJ;AAKE;EACE,wBAAA;AAHJ;AAKE;EACE,2BAAA;AAHJ;AAKI;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;AAHN;AAOE;EACE;IACE,wBAAA;EALJ;EAOE;IACE,wBAAA;EALJ;AACF","sourcesContent":[".card-pill {\n  position: relative;\n  width: 100%;\n  border-radius: 0 4px 0 0;\n  overflow: hidden;\n  height: 184px;\n  margin: 24px 0;\n\n  a {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  &__text {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    color: var(--sebrae-white);\n    background-color: rgba(20, 46, 82, 0.5);\n  }\n  h3 {\n    font: {\n      size: 20px;\n      weight: 700;\n    };\n    line-height: 1.2;\n  }\n  p {\n    font: {\n      size: 16px;\n      weight: 700;\n    };\n    line-height: 1.2;\n    margin-top: 3px;\n  }\n  img, iframe {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  &__desktop {\n    display: none!important;\n  }\n  &.right {\n    border-radius: 0!important;\n\n    .card-pill__text {\n      justify-content: flex-end;\n      text-align: right;\n      padding: 24px;\n    }\n  }\n\n  @media screen and (min-width: 1025px){\n    &__mobile {\n      display: none!important;\n    }\n    &__desktop {\n      display: flex!important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
